export default __webpack_public_path__ + "static/media/service2.70de0611.jpg";